import {
    BOOKING_EXPORT,
    BOOKING_EXPORT_FAILURE,
    BOOKING_EXPORT_SUCCESS,
} from 'store/actions/types';

export const exportBookings = (params) => {
    return {
        type: BOOKING_EXPORT,
        params: params,
    };
};

export const exportBookingsFailure = () => {
    return {
        type: BOOKING_EXPORT_FAILURE,
        error: true,
    };
};

export const exportBookingsSuccess = () => {
    return {
        type: BOOKING_EXPORT_SUCCESS,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/bookings/exportBookings.js